import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import TerminalIcon from '@material-ui/icons/Code';

// The sidebar only discovers pages that output a routeRef; without one the
// nav item is dropped before `nav.take` ever sees it.
const rootRouteRef = createRouteRef();

export const kubectlPage = PageBlueprint.make({
  params: {
    path: '/kubectl',
    routeRef: rootRouteRef,
    // The page renders its own Page/Header, matching the other tool pages.
    noHeader: true,
    loader: async () => {
      const { KubectlPage } = await import('./KubectlPage');
      return <KubectlPage />;
    },
  },
});

export default createFrontendPlugin({
  pluginId: 'kubectl',
  title: 'Kubectl Helper',
  icon: <TerminalIcon />,
  routes: { root: rootRouteRef },
  extensions: [kubectlPage],
});
